// extracted by mini-css-extract-plugin
export default {"table":"ModalDadosTabelaExtracao_table__IXoqd"};